import { ref } from 'vue';

const getWorktimeAlarms = () => {
    const worktimealarms_error = ref(null);
    const worktimealarms = ref(null);

    const loadWorktimeAlarms = async ( monitor_others, view_locations) => {  // location_id = null
        try {
            var params = [];
            // if (location_id) {
            //     params.push(['location_id', location_id]);
            // }

            // if (window.location.href.indexOf("view_all=1") !== -1) {
            //     params.push(['monitor_others', 1]);
            // }
            params.push(['monitor_others',monitor_others]);
            params.push(['view_locations', view_locations]);

            let data = await fetch("/api/worktimealarms?" + new URLSearchParams(params));

            //console.log("data WorktimeAlarms: ", data);
            if (!data.ok) {
                throw Error("Can't load data");
            }

            worktimealarms.value = await data.json();
            worktimealarms.value.forEach( function (worktime) {
                if (worktime.in_at) {
                    worktime.in_at = new Date( worktime.in_at );
                }
                if (worktime.start_at) {
                    worktime.start_at = new Date( worktime.start_at );
                }

                if (worktime.worked_hours) {
                    worktime.worked_hours = parseFloat(worktime.worked_hours);
                }
                if (worktime.workhours) {
                    worktime.workhours = parseFloat(worktime.workhours);
                }
                var now = new Date();
                if (worktime.start_at.getTime() < now.getTime() - 86400000) {
                    worktime.warn = true;
                }
            });

        } catch (err) {
            worktimealarms_error.value = err.message;
        }
    };

    const alarmOK = async (worktimealarm, adjust) => {
        const tokenResponse = await fetch( '/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
          });
          const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(worktimealarm)
        };

        try {
            const response = await fetch('/api/worktimealarms/' + worktimealarm.id + "?adjust=" + adjust, requestOptions);
            if (!response.ok) {
                console.log(response.body);
            }
            const data = await response.text();
        } catch (err) {
            worktimealarms_error.value = err.message;
            console.log(err.message);
        }
    };

    return { worktimealarms, worktimealarms_error, loadWorktimeAlarms, alarmOK };
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default getWorktimeAlarms;
      